import i18next from "../../../i18n";

i18next.addResourceBundle("en", "DataTable", {
    no_results: "No results",
});

i18next.addResourceBundle("fr", "DataTable", {
    no_results: "Aucun résultat",
});
